import moment from 'moment';
import { useState } from 'react';
import {
  Calendar,
  EventProps,
  momentLocalizer,
  Views,
} from 'react-big-calendar';
import { CalendarEvent } from '../../../types/common';
import AcademiaCalendarToolbar from './AcademiaCalendarToolbar';
import AppointmentCalendarEvent from './AppointmentCalendarEvent';

const AcademiaCalendar = ({
  events,
  layoutId,
}: {
  events: Array<CalendarEvent>;
  layoutId: string;
}) => {
  // integration of react hooks here
  const [currentView, setCurrentView] = useState<
    (typeof Views)[keyof typeof Views]
  >(Views.MONTH);
  const [date, setDate] = useState<Date>(new Date());

  // initiating localizer here
  const localizer = momentLocalizer(moment);

  // creating custom components for the calendar here
  const components: any = {
    event: ({ event }: EventProps<CalendarEvent>) => {
      const data = event.data;

      return (
        <AppointmentCalendarEvent
          event={data}
          startingDate={event.start}
          currentView={currentView}
          setCurrentView={setCurrentView}
          setDate={setDate}
        />
      );
    },
  };

  // rendering custom calender component here
  return (
    <div>
      <AcademiaCalendarToolbar
        currentView={currentView}
        setCurrentView={setCurrentView}
        date={date}
        setDate={setDate}
        layoutId={layoutId}
      />

      <div className='overflow-x-auto'>
        <div className='h-[400px] md:h-[550px] min-w-[800px]'>
          <Calendar
            localizer={localizer}
            views={['month', 'week', 'day']}
            view={currentView}
            date={date}
            events={events}
            toolbar={false}
            components={components}
            onView={(view) => setCurrentView(view)}
            onNavigate={(date, view) => {
              setDate(date);
              setCurrentView(view);
            }}
            onShowMore={(_, date) => {
              setDate(date);
              setCurrentView(Views.DAY);
            }}
            step={currentView === 'week' ? 5 : 10}
          />
        </div>
      </div>
    </div>
  );
};

export default AcademiaCalendar;
